import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { SvgIconComponent } from 'angular-svg-icon';
import {
  CorrelationMarkerIconProperty,
  getCorrelationMarkerIcon,
} from '@app/main/main-content/map/config/correlation-marker-icon';
import { MapType } from '@app/main/main-content/map/enums/map-type.enum';
import { CorrelationType } from '@app/core/enums/correlation-type.enum';
import { NgClass } from '@angular/common';
import { CommonStateStatus } from '@app/core/enums/common-state-status.enum';
import { isUnknownMarkerIcon } from '@app/main/main-content/map/config/unknown-marker-icon';

@Component({
  selector: 'gc-ld-correlation-type-icon',
  imports: [SvgIconComponent, NgClass],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './ld-correlation-type-icon.component.html',
  styleUrl: './ld-correlation-type-icon.component.scss',
  host: {
    class: 'flex items-center justify-center',
  },
})
export class LdCorrelationTypeIconComponent {
  protected readonly CorrelationType = CorrelationType;
  protected readonly CommonStateStatus = CommonStateStatus;

  public correlationType = input.required<CorrelationType>();
  public correlationStateStatus = input.required<CommonStateStatus>();
  public size = input<`${number}rem`>('1.75rem');

  public markerIcon = computed(() => {
    const correlationType = this.correlationType();
    const qualityStatus = this.correlationStateStatus();
    const mapTypeId = MapType.Roadmap;

    return {
      src: getCorrelationMarkerIcon(mapTypeId, correlationType, qualityStatus, CorrelationMarkerIconProperty.Src),
      name: getCorrelationMarkerIcon(mapTypeId, correlationType, qualityStatus, CorrelationMarkerIconProperty.Name),
    };
  });

  public isUnknownMarkerIcon = computed(() => {
    const markerIcon = this.markerIcon();

    return isUnknownMarkerIcon(markerIcon.src);
  });
}
